const Index = () => import(/* webpackChunkName: "user" */ './index.vue');
const Edit = () => import(/* webpackChunkName: "user" */ './components/Edit.vue');
const Profile = () => import(/* webpackChunkName: "user" */ './view/Profile.vue');
const MatchmakingPreferences = () =>
  import(/* webpackChunkName: "user" */ '@/modules/User/components/MatchmakingPreferences.vue');

export default [
  {
    path: 'user',
    name: 'user',
    component: Index,
    title: 'User',
    redirect: { name: 'user-profile' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'profile',
        name: 'user-profile',
        component: Profile,
        meta: { requiresAuth: true },
      },
      {
        path: 'edit',
        name: 'user-edit',
        component: Edit,
        meta: { requiresAuth: true },
      },
      {
        path: 'matchmaking-preferences',
        name: 'user-matchmaking-preferences',
        component: MatchmakingPreferences,
        meta: { requiresAuth: true },
      },
    ],
  },
];